(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(28840);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4968:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/expressLogo.e34ac1f5.svg","height":58,"width":138});

/***/ }),

/***/ 20353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/StyledCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 3s ease infinite;\n      background-size: 400% 400%;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // background: ",
        ";\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  position: relative;\n\n  ",
        "\n\n  padding: 1px 1px 3px 1px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  overflow: ",
        ";\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var PromotedGradient = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
/**
 * Priority: Warning --> Success --> Active
 */ var getBorderColor = function getBorderColor(param) {
    var isActive = param.isActive, isSuccess = param.isSuccess, isWarning = param.isWarning, borderBackground = param.borderBackground, theme = param.theme;
    if (borderBackground) {
        return borderBackground;
    }
    if (isWarning) {
        return theme.colors.warning;
    }
    if (isSuccess) {
        return theme.colors.success;
    }
    if (isActive) {
        return "linear-gradient(180deg, ".concat(theme.colors.primaryBright, ", ").concat(theme.colors.secondary, ")");
    }
    return theme.colors.cardBorder;
};
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-732488c6-0"
}).withConfig({
    componentId: "sc-9bd1ff63-0"
})(_templateObject2(), getBorderColor, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme, isDisabled = param.isDisabled;
    return theme.colors[isDisabled ? "textDisabled" : "text"];
}, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), PromotedGradient);
}, index_esm/* space */.Dh);
var StyledCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-732488c6-1"
}).withConfig({
    componentId: "sc-9bd1ff63-1"
})(_templateObject3(), function(param) {
    var hasCustomBorder = param.hasCustomBorder;
    return hasCustomBorder ? "initial" : "inherit";
}, function(param) {
    var theme = param.theme, background = param.background;
    return background !== null && background !== void 0 ? background : theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
StyledCard.defaultProps = {
    isActive: false,
    isSuccess: false,
    isWarning: false,
    isDisabled: false
};

;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/Card.tsx






var Card = function Card(_param) {
    var ribbon = _param.ribbon, children = _param.children, background = _param.background, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ribbon",
        "children",
        "background"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardInner, {
            background: background,
            hasCustomBorder: !!props.borderBackground,
            children: [
                ribbon,
                children
            ]
        })
    }));
};
/* harmony default export */ var Card_Card = (Card);


/***/ }),

/***/ 70257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardBody = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-df4f0a61-0"
}).withConfig({
    componentId: "sc-657c9e-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
CardBody.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardBody);


/***/ }),

/***/ 78593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5 7C5 6.44772 4.55228 6 4 6C3.44772 6 3 6.44772 3 7V18C3 19.1046 3.89543 20 5 20H20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18H5V7Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19 17H7C6.44772 17 6 16.5523 6 16V12C6 11.4477 6.44772 11 7 11H10V10C10 9.44772 10.4477 9 11 9H14V7C14 6.44772 14.4477 6 15 6H19C19.5523 6 20 6.44772 20 7V16C20 16.5523 19.5523 17 19 17ZM16 8H18V15H16V8ZM12 15H14V11H12V15ZM10 13H8V15H10V13Z"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 21184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44976);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M4 13C5.1 13 6 12.1 6 11C6 9.9 5.1 9 4 9C2.9 9 2 9.9 2 11C2 12.1 2.9 13 4 13ZM5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58C0.48 14.9 0 15.62 0 16.43V17C0 17.5523 0.447715 18 1 18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1ZM20 13C21.1 13 22 12.1 22 11C22 9.9 21.1 9 20 9C18.9 9 18 9.9 18 11C18 12.1 18.9 13 20 13ZM24 16.43C24 15.62 23.52 14.9 22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H23C23.5523 18 24 17.5523 24 17V16.43ZM16.24 13.65C15.07 13.13 13.63 12.75 12 12.75C10.37 12.75 8.93 13.14 7.76 13.65C6.68 14.13 6 15.21 6 16.39V17C6 17.5523 6.44772 18 7 18H17C17.5523 18 18 17.5523 18 17V16.39C18 15.21 17.32 14.13 16.24 13.65ZM8.07 16C8.16 15.77 8.2 15.61 8.98 15.31C9.95 14.93 10.97 14.75 12 14.75C13.03 14.75 14.05 14.93 15.02 15.31C15.79 15.61 15.83 15.77 15.93 16H8.07ZM12 8C12.55 8 13 8.45 13 9C13 9.55 12.55 10 12 10C11.45 10 11 9.55 11 9C11 8.45 11.45 8 12 8ZM12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 74822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PageSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(44305);
// EXTERNAL MODULE: ./src/components/PageSection/svg/CurvedSvg.tsx
var CurvedSvg = __webpack_require__(966);
;// CONCATENATED MODULE: ./src/components/PageSection/CurvedDivider.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  z-index: ",
        ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82a6e052-0"
})(_templateObject(), function(param) {
    var theme = param.theme, dividerFill = param.dividerFill;
    if (theme.isDark) {
        return (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.dark) || (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.light) || "none";
    }
    return (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.light) || (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.dark) || "none";
}, function(param) {
    var index = param.index;
    return index;
});
var ComponentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82a6e052-1"
})(_templateObject1(), function(param) {
    var index = param.index;
    return index + 1;
});
var CurvedDivider = function(param) {
    var index = param.index, dividerPosition = param.dividerPosition, dividerComponent = param.dividerComponent, concave = param.concave, clipFill = param.clipFill, dividerFill = param.dividerFill;
    var showConvexTop = dividerPosition === "top" && !concave;
    var showConvexBottom = dividerPosition === "bottom" && !concave;
    var showConcaveTop = dividerPosition === "top" && concave;
    var showConcaveBottom = dividerPosition === "bottom" && concave;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        index: index,
        dividerFill: dividerFill,
        children: [
            dividerComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper, {
                index: index,
                children: dividerComponent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showConcaveTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConcaveTop */.n6, {
                        clipFill: clipFill
                    }),
                    showConcaveBottom && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConcaveBottom */.CT, {
                        clipFill: clipFill
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showConvexTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConvexTop */.Z5, {
                        clipFill: clipFill
                    }),
                    showConvexBottom && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConvexBottom */.kZ, {
                        clipFill: clipFill
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PageSection_CurvedDivider = (CurvedDivider);

;// CONCATENATED MODULE: ./src/components/PageSection/index.tsx




function PageSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-direction: column;\n  align-items: center;\n  z-index: ",
        ";\n  padding: ",
        ";\n"
    ]);
    PageSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PageSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: auto;\n  padding-top: 16px;\n  padding-bottom: 16px;\n\n  ",
        " {\n    padding-top: 32px;\n    padding-bottom: 32px;\n  }\n\n  ",
        " {\n    padding-top: 48px;\n    padding-bottom: 48px;\n  }\n"
    ]);
    PageSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var BackgroundColor = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    className: "page-bg"
}).withConfig({
    componentId: "sc-308e1ef1-0"
})(PageSection_templateObject(), function(param) {
    var index = param.index;
    return index - 1;
}, function(param) {
    var padding = param.padding;
    return padding;
});
var ChildrenWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-308e1ef1-1"
})(PageSection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var PageSection = function(_param) {
    var children = _param.children, svgFill = _param.svgFill, _index = _param.index, index = _index === void 0 ? 1 : _index, dividerComponent = _param.dividerComponent, _dividerPosition = _param.dividerPosition, dividerPosition = _dividerPosition === void 0 ? "bottom" : _dividerPosition, _hasCurvedDivider = _param.hasCurvedDivider, hasCurvedDivider = _hasCurvedDivider === void 0 ? true : _hasCurvedDivider, _concaveDivider = _param.concaveDivider, concaveDivider = _concaveDivider === void 0 ? false : _concaveDivider, clipFill = _param.clipFill, dividerFill = _param.dividerFill, containerProps = _param.containerProps, innerProps = _param.innerProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "svgFill",
        "index",
        "dividerComponent",
        "dividerPosition",
        "hasCurvedDivider",
        "concaveDivider",
        "clipFill",
        "dividerFill",
        "containerProps",
        "innerProps"
    ]);
    var padding = (0,react.useMemo)(function() {
        // No curved divider
        if (!hasCurvedDivider) {
            return "48px 0";
        }
        // Bottom curved divider
        // Less bottom padding, as the divider is present there
        if (dividerPosition === "bottom") {
            return "48px 0 14px";
        }
        // Top curved divider
        // Less top padding, as the divider is present there
        if (dividerPosition === "top") {
            return "14px 0 48px";
        }
        return "48px 0";
    }, [
        dividerPosition,
        hasCurvedDivider
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, containerProps), {
        children: [
            hasCurvedDivider && dividerPosition === "top" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection_CurvedDivider, {
                svgFill: svgFill,
                index: index,
                concave: concaveDivider,
                dividerPosition: dividerPosition,
                dividerComponent: dividerComponent,
                clipFill: clipFill,
                dividerFill: dividerFill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundColor, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                index: index,
                padding: padding
            }, props), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, innerProps), {
                    children: children
                }))
            })),
            hasCurvedDivider && dividerPosition === "bottom" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection_CurvedDivider, {
                svgFill: svgFill,
                index: index,
                concave: concaveDivider,
                dividerPosition: dividerPosition,
                dividerComponent: dividerComponent,
                clipFill: clipFill,
                dividerFill: dividerFill
            })
        ]
    }));
};
/* harmony default export */ var components_PageSection = (PageSection);


/***/ }),

/***/ 966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ ConcaveBottom; },
/* harmony export */   "Z5": function() { return /* binding */ ConvexTop; },
/* harmony export */   "kZ": function() { return /* binding */ ConvexBottom; },
/* harmony export */   "n6": function() { return /* binding */ ConcaveTop; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 20px;\n  clip-path: url(",
        ");\n\n  background: ",
        ";\n\n  & svg {\n    display: block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  transform: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  transform: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var sharedStyles = function(theme, clipPath, clipFill) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), clipPath, function() {
        if (theme.isDark) {
            return (clipFill === null || clipFill === void 0 ? void 0 : clipFill.dark) || (clipFill === null || clipFill === void 0 ? void 0 : clipFill.light) || theme.colors.background;
        }
        return (clipFill === null || clipFill === void 0 ? void 0 : clipFill.light) || theme.colors.background;
    });
};
var ConcaveContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f0d6319c-0"
})(_templateObject1(), function(param) {
    var theme = param.theme, clipPath = param.clipPath, clipFill = param.clipFill;
    return sharedStyles(theme, clipPath, clipFill);
}, function(param) {
    var clipPath = param.clipPath;
    return clipPath === "#bottomConcaveCurve" ? "translate(0, -13px)" : "translate(0, 1px)";
});
var ConvexContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f0d6319c-1"
})(_templateObject2(), function(param) {
    var theme = param.theme, clipPath = param.clipPath, clipFill = param.clipFill;
    return sharedStyles(theme, clipPath, clipFill);
}, function(param) {
    var clipPath = param.clipPath;
    return clipPath === "#bottomConvexCurve" ? "translate(0, -13px)" : "translate(0, -1px)";
});
var ConvexTop = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConvexContainer, {
        clipFill: clipFill,
        clipPath: "#topConvexCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "topConvexCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,1 L 0,0 L 1,0 L 1,1 C 0.75 0, .25 0, 0 1 Z"
                    })
                })
            })
        })
    });
};
var ConvexBottom = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConvexContainer, {
        clipFill: clipFill,
        clipPath: "#bottomConvexCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "bottomConvexCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,0 L 0,1 L 1,1 L 1,0 C .75 1, .25 1, 0 0 Z"
                    })
                })
            })
        })
    });
};
var ConcaveTop = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConcaveContainer, {
        clipFill: clipFill,
        clipPath: "#topConcaveCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "topConcaveCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,0 L 0,1 L 1,1 L 1,0 C .75 1, .25 1, 0 0 Z"
                    })
                })
            })
        })
    });
};
var ConcaveBottom = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConcaveContainer, {
        clipFill: clipFill,
        clipPath: "#bottomConcaveCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "bottomConcaveCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,1 L 0,0 L 1,0 L 1,1 C .75 0.1, .25 0.1, 0 1 Z"
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 28840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/PageSection/index.tsx + 1 modules
var PageSection = __webpack_require__(74822);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(29315);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(44305);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(27553);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var localization_src = __webpack_require__(52775);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(56797);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(69589);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(7447);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./public/images/newthemeimages/expressLogo.svg
var expressLogo = __webpack_require__(4968);
;// CONCATENATED MODULE: ./src/views/Home/components/Hero.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translate(0,  0px);\n  }\n  50% {\n    transform: translate(-5px, -5px);\n  }\n  to {\n    transform: translate(0, 0px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    opacity: 0.9;\n  }\n  50% {\n    opacity: 0.1;\n  }\n  to {\n    opacity: 0.9;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: -1;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  bottom: 0px;\n  left: 0px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n  bottom: -3px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  animation: ",
        " 3.5s ease-in-out infinite;\n  will-change: transform;\n  > span {\n    overflow: visible !important; // make sure the next-image pre-build blur image not be cropped\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  & :nth-child(2) {\n    animation: ",
        " 2s ease-in-out infinite;\n    animation-delay: 1s;\n  }\n\n  & :nth-child(3) {\n    animation: ",
        " 5s ease-in-out infinite;\n    animation-delay: 0.66s;\n  }\n\n  & :nth-child(4) {\n    animation: ",
        " 2.5s ease-in-out infinite;\n    animation-delay: 0.33s;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}








var flyingAnim = function() {
    return (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
};
var fading = function() {
    return (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
};
var BgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-523f507-0"
})(_templateObject2());
var InnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-523f507-1"
})(_templateObject3());
var BunnyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-523f507-2"
})(_templateObject4(), flyingAnim);
var StarsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-523f507-3"
})(_templateObject5(), fading, fading, fading);
var starsImage = {
    path: "/images/home/lunar-bunny/",
    attributes: [
        {
            src: "star-l",
            alt: "3D Star"
        },
        {
            src: "star-r",
            alt: "3D Star"
        },
        {
            src: "star-top-r",
            alt: "3D Star"
        }, 
    ]
};
var Hero = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var account = (0,src/* useWeb3React */.Ge)().account;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
            position: "relative",
            height: "100vh",
            flexDirection: [
                "column-reverse",
                null,
                null,
                "row"
            ],
            alignItems: [
                "flex-end",
                null,
                null,
                "center"
            ],
            justifyContent: "center",
            mt: [
                account ? "100px" : "100px",
                null,
                0
            ],
            id: "homepage-hero",
            width: "100%",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flex: "1",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: [
                    "center",
                    "center",
                    "center",
                    "center"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mb: "100px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: expressLogo/* default */.Z,
                            alt: "no-icon",
                            height: 100,
                            width: 300
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: "xxl",
                        mb: "4px",
                        children: t("Trade, Invest, Earn 24/7")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: "xxl",
                        mb: "45px",
                        children: t("With GEXPRESS build V.2")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mb: "45px",
                        textAlign: "center",
                        width: "80%",
                        fontSize: 24,
                        children: t("Trade and Invest in Cryptocurrencies, Stocks, ETFs, Forex, Currencies, Indices and Commodities- all in one place. Just connect your wallet and begin trading 24/7 with no minimums or trading pair restrictions.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: !account && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                            mr: "8px"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_Hero = (Hero);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Community.tsx
var Community = __webpack_require__(21184);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Swap.tsx
var Swap = __webpack_require__(47811);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Chart.tsx
var Chart = __webpack_require__(78593);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var immutable_dist = __webpack_require__(49770);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(20353);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(70257);
;// CONCATENATED MODULE: ./src/views/Home/components/IconCard.tsx




function IconCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: fit-content;\n  padding: 1px 1px 4px 1px;\n  box-sizing: border-box;\n  border: none;\n  display: flex;\n  // justify-content: center;\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    IconCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IconCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  // top: 24px;\n  // right: 24px;\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    IconCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-ed4034f4-0"
})(IconCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var rotation = param.rotation;
    return rotation ? "transform: rotate(".concat(rotation, ");") : "";
});
var IconWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-ed4034f4-1"
})(IconCard_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var rotation = param.rotation;
    return rotation ? "transform: rotate(".concat(rotation, ");") : "";
});
var IconCard = function(_param) {
    var icon = _param.icon, background = _param.background, borderColor = _param.borderColor, rotation = _param.rotation, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "icon",
        "background",
        "borderColor",
        "rotation",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        background: background,
        borderBackground: borderColor,
        rotation: rotation
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
            style: {
                display: "flex",
                justifyContent: "center",
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                    rotation: rotation,
                    children: icon
                }),
                children
            ]
        })
    }));
};
/* harmony default export */ var components_IconCard = (IconCard);

// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(34701);
;// CONCATENATED MODULE: ./src/views/Home/components/MetricsSection/StatCardContent.tsx


var StatCardContent = function(param) {
    var headingText = param.headingText, bodyText = param.bodyText, highlightColor = param.highlightColor;
    var ref = (0,useMatchBreakpoints/* default */.Z)(), isMobile = ref.isMobile, isTablet = ref.isTablet;
    var isSmallerScreen = isMobile || isTablet;
    var split = headingText.split(" ");
    var lastWord = split.pop();
    var remainingWords = split.slice(0, split.length).join(" ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        minHeight: [
            null,
            null,
            null,
            null
        ],
        height: "250px",
        maxWidth: "200px",
        flexDirection: "column",
        // justifyContent="flex-end"
        mt: [
            null,
            null,
            null,
            null
        ],
        children: [
            isSmallerScreen && remainingWords.length > 13 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                scale: "lg",
                children: remainingWords
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                scale: "xl",
                children: remainingWords
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                color: highlightColor,
                scale: "xl",
                mb: "24px",
                children: lastWord
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                children: bodyText
            })
        ]
    });
};
/* harmony default export */ var MetricsSection_StatCardContent = (StatCardContent);

;// CONCATENATED MODULE: ./src/views/Home/components/MetricsSection/index.tsx









var Stats = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = (0,immutable_dist/* default */.Z)("tvl"), tvl = ref.data;
    var ref1 = (0,immutable_dist/* default */.Z)("totalTx30Days"), txCount = ref1.data;
    var ref2 = (0,immutable_dist/* default */.Z)("addressCount30Days"), addressCount = ref2.data;
    var trades = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(txCount);
    var users = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(addressCount);
    var tvlString = tvl ? (0,formatBalance/* formatLocalisedCompactNumber */.uI)(tvl) : "-";
    var tvlText = t("And those users are now entrusting the platform with over $%tvl% in funds.", {
        tvl: tvlString
    });
    var ref3 = (0,_sliced_to_array/* default */.Z)(tvlText.split(tvlString), 2), entrusting = ref3[0], inFunds = ref3[1];
    var UsersCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Community/* default */.Z, {
            color: "secondary",
            width: "36px"
        })
    };
    var TradesCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Swap/* default */.Z, {
            color: "primary",
            width: "36px"
        })
    };
    var StakedCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart/* default */.Z, {
            color: "failure",
            width: "36px"
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                textAlign: "center",
                scale: "xxl",
                children: t("What Makes GEXPRESS ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                textAlign: "center",
                scale: "xxl",
                mb: "80px",
                color: "secondary",
                children: t("Unique?")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: [
                    "column",
                    null,
                    null,
                    "row"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, {
                        mr: [
                            null,
                            null,
                            null,
                            "16px"
                        ],
                        mb: [
                            "16px",
                            null,
                            null,
                            "0"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection_StatCardContent, {
                            headingText: t("01", {
                                users: users
                            }),
                            bodyText: t("Unlike other protocols that profit off maker and taker fees and are widespread in the community today, we guarantees the best execution price with the tightest spread every time."),
                            highlightColor: theme.colors.secondary
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, {
                        mr: [
                            null,
                            null,
                            null,
                            "16px"
                        ],
                        mb: [
                            "16px",
                            null,
                            null,
                            "0"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection_StatCardContent, {
                            headingText: t("02", {
                                trades: trades
                            }),
                            bodyText: t("GEXPRESS liquidity pools are continuously optimized to earn yield generated from functions such as automated market making and safe margin lending that continually redeploy to compound."),
                            highlightColor: theme.colors.primary
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection_StatCardContent, {
                            headingText: t("03", {
                                tvl: tvlString
                            }),
                            bodyText: t("GEXPRESS integrates the highest cryptographic safeguards and best practices while adding WebAuthn protocols."),
                            highlightColor: theme.colors.failure
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MetricsSection = (Stats);

;// CONCATENATED MODULE: ./src/views/Home/components/Crypto/CryptoCardContent.tsx


var CryptoCardContent = function(param) {
    var headingText = param.headingText, bodyText = param.bodyText, highlightColor = param.highlightColor;
    var ref = (0,useMatchBreakpoints/* default */.Z)(), isMobile = ref.isMobile, isTablet = ref.isTablet;
    var isSmallerScreen = isMobile || isTablet;
    //   const split = headingText.split(' ')
    //   const lastWord = split.pop()
    //   const remainingWords = split.slice(0, split.length).join(' ')
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        minHeight: [
            null,
            null,
            null,
            null
        ],
        height: "250px",
        width: "200px",
        flexDirection: "column",
        // justifyContent="flex-end"
        mt: [
            null,
            null,
            null,
            null
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            color: "secondary",
            mt: [
                "196px",
                "196px",
                "196px",
                "196px"
            ],
            children: bodyText
        })
    });
};
/* harmony default export */ var Crypto_CryptoCardContent = (CryptoCardContent);

;// CONCATENATED MODULE: ./public/images/home/b.svg
/* harmony default export */ var b = ({"src":"/_next/static/media/b.875c98e0.svg","height":161,"width":140});
;// CONCATENATED MODULE: ./public/images/home/Group.svg
/* harmony default export */ var Group = ({"src":"/_next/static/media/Group.fdf48ac2.svg","height":160,"width":161});
;// CONCATENATED MODULE: ./public/images/home/stake.svg
/* harmony default export */ var stake = ({"src":"/_next/static/media/stake.c554e739.svg","height":160,"width":219});
;// CONCATENATED MODULE: ./public/images/home/swap.svg
/* harmony default export */ var swap = ({"src":"/_next/static/media/swap.58757fe7.svg","height":160,"width":231});
;// CONCATENATED MODULE: ./src/views/Home/components/Crypto/index.tsx
















var Crypto = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = (0,immutable_dist/* default */.Z)("tvl"), tvl = ref.data;
    var ref1 = (0,immutable_dist/* default */.Z)("totalTx30Days"), txCount = ref1.data;
    var ref2 = (0,immutable_dist/* default */.Z)("addressCount30Days"), addressCount = ref2.data;
    var trades = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(txCount);
    var users = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(addressCount);
    var tvlString = tvl ? (0,formatBalance/* formatLocalisedCompactNumber */.uI)(tvl) : "-";
    var tvlText = t("And those users are now entrusting the platform with over $%tvl% in funds.", {
        tvl: tvlString
    });
    var ref3 = (0,_sliced_to_array/* default */.Z)(tvlText.split(tvlString), 2), entrusting = ref3[0], inFunds = ref3[1];
    var UsersCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: Group,
            width: "150",
            style: {
                paddingLeft: "40px"
            }
        })
    };
    var TradesCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: b,
            width: "150",
            style: {
                paddingLeft: "40px"
            }
        })
    };
    var StakedCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: stake,
            width: "150",
            style: {
                paddingLeft: "40px"
            }
        })
    };
    var SwapCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: swap,
            width: "150",
            style: {
                paddingLeft: "40px"
            }
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                textAlign: "center",
                scale: "xxl",
                children: t("Earn passive income with ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                textAlign: "center",
                scale: "xxl",
                mb: "52px",
                color: "secondary",
                children: t("CRYPTO")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: [
                    "column",
                    "column",
                    "column",
                    "column",
                    "row"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, UsersCardData), {
                        mr: [
                            null,
                            null,
                            null,
                            "16px"
                        ],
                        mb: [
                            "16px",
                            "16px",
                            "16px",
                            "16px"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Crypto_CryptoCardContent, {
                            headingText: t("01", {
                                users: users
                            }),
                            bodyText: t("Farms"),
                            highlightColor: theme.colors.secondary
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, TradesCardData), {
                        mr: [
                            null,
                            null,
                            null,
                            "16px"
                        ],
                        mb: [
                            "16px",
                            "16px",
                            "16px",
                            "16px"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Crypto_CryptoCardContent, {
                            headingText: t("02", {
                                trades: trades
                            }),
                            bodyText: t("Liquidity Pools"),
                            highlightColor: theme.colors.primary
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, StakedCardData), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Crypto_CryptoCardContent, {
                            headingText: t("03", {
                                tvl: tvlString
                            }),
                            bodyText: t("Staking"),
                            highlightColor: theme.colors.failure
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, SwapCardData), {
                        mt: [
                            "16px",
                            "16px",
                            "16px",
                            "16px",
                            "0px"
                        ],
                        ml: [
                            "16px",
                            "16px",
                            "16px",
                            "16px"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Crypto_CryptoCardContent, {
                            headingText: t("02", {
                                trades: trades
                            }),
                            bodyText: t("Swap"),
                            highlightColor: theme.colors.primary
                        })
                    }))
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Crypto = (Crypto);

;// CONCATENATED MODULE: ./public/images/phone.svg
/* harmony default export */ var phone = ({"src":"/_next/static/media/phone.e240958f.svg","height":572,"width":869});
;// CONCATENATED MODULE: ./src/views/Home/components/AllInOne/index.tsx









var AllinOne = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = (0,immutable_dist/* default */.Z)("tvl"), tvl = ref.data;
    var ref1 = (0,immutable_dist/* default */.Z)("totalTx30Days"), txCount = ref1.data;
    var ref2 = (0,immutable_dist/* default */.Z)("addressCount30Days"), addressCount = ref2.data;
    var trades = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(txCount);
    var users = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(addressCount);
    var tvlString = tvl ? (0,formatBalance/* formatLocalisedCompactNumber */.uI)(tvl) : "-";
    var tvlText = t("And those users are now entrusting the platform with over $%tvl% in funds.", {
        tvl: tvlString
    });
    var ref3 = (0,_sliced_to_array/* default */.Z)(tvlText.split(tvlString), 2), entrusting = ref3[0], inFunds = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: phone,
                    width: "500px",
                    alt: "phone"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    textAlign: "center",
                    scale: "xxl",
                    mb: "0px",
                    children: t("SWAP. STAKE. FARM")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    textAlign: "center",
                    scale: "xxl",
                    mb: "32px",
                    color: "secondary",
                    children: t("ALL IN ONE PLACE")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    display: "inline",
                    textAlign: "center",
                    color: "textSubtle",
                    mb: "20px",
                    fontSize: "24",
                    fontWeight: "600",
                    children: "Synthetic assets provide exposure to an asset without holding the underlying resource. Synths offer many advantages, including reducing the friction when switching between trading assets and among different asset classes. For example, one can trade Apple shares to synthetic gold to Bitcoin. GEXPRESS is expanding the accessibility of certain assets and censorship resistance in one unified, easy-to-use, intuitive user interface."
                })
            ]
        })
    });
};
/* harmony default export */ var AllInOne = (AllinOne);

;// CONCATENATED MODULE: ./src/views/Home/components/IconStart.tsx




function IconStart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: fit-content;\n  padding: 1px 1px 4px 1px;\n  box-sizing: border-box;\n  display: flex;\n  border: none;\n  // justify-content: center;\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    IconStart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IconStart_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  // top: 24px;\n  // right: 24px;\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    IconStart_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var IconStart_StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-376387c-0"
})(IconStart_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var rotation = param.rotation;
    return rotation ? "transform: rotate(".concat(rotation, ");") : "";
});
var IconStart_IconWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-376387c-1"
})(IconStart_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var rotation = param.rotation;
    return rotation ? "transform: rotate(".concat(rotation, ");") : "";
});
var IconStart = function(_param) {
    var icon = _param.icon, background = _param.background, borderColor = _param.borderColor, rotation = _param.rotation, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "icon",
        "background",
        "borderColor",
        "rotation",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStart_StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        background: background,
        borderBackground: borderColor,
        rotation: rotation
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
            style: {
                display: "flex",
                textAlign: "left"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStart_IconWrapper, {
                    rotation: rotation,
                    children: icon
                }),
                children
            ]
        })
    }));
};
/* harmony default export */ var components_IconStart = (IconStart);

;// CONCATENATED MODULE: ./src/views/Home/components/SocialCards/SocialCardContent.tsx


var SocialCardContent = function(param) {
    var bodyText = param.bodyText, highlightColor = param.highlightColor, bodyName = param.bodyName;
    var ref = (0,useMatchBreakpoints/* default */.Z)(), isMobile = ref.isMobile, isTablet = ref.isTablet;
    var isSmallerScreen = isMobile || isTablet;
    //   const split = headingText.split(' ')
    //   const lastWord = split.pop()
    //   const remainingWords = split.slice(0, split.length).join(' ')
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        minHeight: [
            null,
            null,
            null,
            null
        ],
        height: "250px",
        maxWidth: "200px",
        flexDirection: "column",
        // justifyContent="flex-end"
        mt: [
            null,
            null,
            null,
            null
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                color: highlightColor,
                scale: "xl",
                mb: "24px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                mt: [
                    "36px",
                    null,
                    null,
                    "36px"
                ],
                children: bodyText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                style: {
                    color: "#ADDB44"
                },
                mt: [
                    "16px",
                    null,
                    null,
                    "16px"
                ],
                children: bodyName
            })
        ]
    });
};
/* harmony default export */ var SocialCards_SocialCardContent = (SocialCardContent);

;// CONCATENATED MODULE: ./public/images/home/social.svg
/* harmony default export */ var social = ({"src":"/_next/static/media/social.8c6bc37a.svg","height":24,"width":35});
;// CONCATENATED MODULE: ./src/views/Home/components/SocialCards/index.tsx










// import IconCard, { IconCardData } from '../IconCard'



var SocialCard = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = (0,immutable_dist/* default */.Z)("tvl"), tvl = ref.data;
    var ref1 = (0,immutable_dist/* default */.Z)("totalTx30Days"), txCount = ref1.data;
    var ref2 = (0,immutable_dist/* default */.Z)("addressCount30Days"), addressCount = ref2.data;
    var trades = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(txCount);
    var users = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(addressCount);
    var tvlString = tvl ? (0,formatBalance/* formatLocalisedCompactNumber */.uI)(tvl) : "-";
    var tvlText = t("And those users are now entrusting the platform with over $%tvl% in funds.", {
        tvl: tvlString
    });
    var ref3 = (0,_sliced_to_array/* default */.Z)(tvlText.split(tvlString), 2), entrusting = ref3[0], inFunds = ref3[1];
    var UsersCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: social,
            width: "36px"
        })
    };
    var TradesCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: social,
            width: "36px"
        })
    };
    var StakedCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: social,
            width: "36px"
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                textAlign: "center",
                scale: "xxl",
                children: t("THE VOICE THAT")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                textAlign: "center",
                scale: "xxl",
                mb: "32px",
                color: "secondary",
                children: t(" MATTERS ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                display: "inline",
                textAlign: "center",
                color: "textSubtle",
                mb: "50px",
                fontSize: "24",
                fontWeight: "600",
                children: "Our unparalleled services reflect in testimonials from these users."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: [
                    "column",
                    null,
                    null,
                    "row"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconStart, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, StakedCardData), {
                        mr: [
                            null,
                            null,
                            null,
                            "16px"
                        ],
                        mb: [
                            "16px",
                            null,
                            null,
                            null
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialCards_SocialCardContent, {
                            headingText: t(""),
                            bodyText: t(" Including reducing the friction when switching between trading assets and among different asset classes."),
                            bodyName: t("Eric Kripke"),
                            highlightColor: theme.colors.secondary
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconStart, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, TradesCardData), {
                        mr: [
                            null,
                            null,
                            null,
                            "16px"
                        ],
                        mb: [
                            "16px",
                            null,
                            null,
                            "0"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialCards_SocialCardContent, {
                            headingText: t(""),
                            bodyText: t("Including reducing the friction when switching between trading assets and among different asset classes."),
                            bodyName: t("Eric Kripke"),
                            highlightColor: theme.colors.primary
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconStart, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, UsersCardData), {
                        mr: [
                            "16px",
                            "16px",
                            "16px",
                            "16px"
                        ],
                        mb: [
                            "16px",
                            "16px",
                            "16px",
                            "0"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialCards_SocialCardContent, {
                            headingText: t(""),
                            bodyName: t("Eric Kripke"),
                            bodyText: t("Including reducing the friction when switching between trading assets and among different asset classes."),
                            highlightColor: theme.colors.failure
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconStart, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, UsersCardData), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialCards_SocialCardContent, {
                            headingText: t(""),
                            bodyName: t("Eric Kripke"),
                            bodyText: t("Including reducing the friction when switching between trading assets and among different asset classes."),
                            highlightColor: theme.colors.failure
                        })
                    }))
                ]
            })
        ]
    });
};
/* harmony default export */ var SocialCards = (SocialCard);

;// CONCATENATED MODULE: ./src/views/Home/index.tsx

function Home_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n\n  ",
        " {\n    padding-top: 48px;\n  }\n"
    ]);
    Home_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Home_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  position: absolute;\n  width: 100%;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n  padding-left: 0px;\n  padding-right: 0px;\n\n  ",
        " {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n"
    ]);
    Home_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Home_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: url('images/home/MaskGroup.jpg');\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n"
    ]);
    Home_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Home_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: url('images/home/maskbg.png');\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n"
    ]);
    Home_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}














var StyledHeroSection = (0,styled_components_browser_esm/* default */.ZP)(PageSection/* default */.Z).withConfig({
    componentId: "sc-85e0009a-0"
})(Home_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var UserBannerWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-85e0009a-1"
})(Home_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var BgDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-85e0009a-2"
})(Home_templateObject2());
var BgHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-85e0009a-3"
})(Home_templateObject3());
var Home = function() {
    var theme = (0,useTheme/* default */.ZP)().theme;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var chainId = (0,useActiveChainId/* useActiveChainId */.gi)().chainId;
    var HomeSectionContainerStyles = {
        marginTop: "10px",
        width: "100%",
        maxWidth: "968px",
        BackgroundImage: "url(../../../public/images/home/Landing Page.png)"
    };
    var t = (0,localization_src/* useTranslation */.$G)().t;
    // const img = require("../../../public/images/home/Landing Page.png");
    //   const styling = {
    //     backgroundImage: `url('${img}')`,
    //     width:"100%",
    //     height:"100%"
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageMeta */.V, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BgHero, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroSection, {
                    innerProps: {
                        style: {
                            margin: "0",
                            width: "100%"
                        }
                    },
                    containerProps: {
                        id: "home-1"
                    },
                    index: 2,
                    hasCurvedDivider: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Hero, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BgDiv, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                        innerProps: {
                            style: {
                                marginTop: "102px",
                                width: "100%"
                            }
                        },
                        containerProps: {
                            id: "home-2"
                        },
                        index: 2,
                        hasCurvedDivider: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                        // innerProps={{ style: HomeSectionContainerStyles }}
                        innerProps: {
                            style: {
                                marginTop: "102px",
                                width: "100%"
                            }
                        },
                        // background={theme.colors.gradientCardHeader}
                        index: 2,
                        hasCurvedDivider: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Crypto, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                        // innerProps={{ style: HomeSectionContainerStyles }}
                        innerProps: {
                            style: {
                                marginTop: "0",
                                width: "100%"
                            }
                        },
                        containerProps: {
                            id: "home-3"
                        },
                        index: 2,
                        hasCurvedDivider: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AllInOne, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                        innerProps: {
                            style: HomeSectionContainerStyles
                        },
                        // background={'../../../public/images/home/Landing Page.png'}
                        index: 2,
                        hasCurvedDivider: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialCards, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var views_Home = (Home);

;// CONCATENATED MODULE: ./src/pages/index.tsx



var IndexPage = function(param) {
    var totalTx30Days = param.totalTx30Days, addressCount30Days = param.addressCount30Days, tvl = param.tvl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SWRConfig */.J$, {
        value: {
            fallback: {
                totalTx30Days: totalTx30Days,
                addressCount30Days: addressCount30Days,
                tvl: tvl
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(views_Home, {})
    });
};
IndexPage.chains = [];
var __N_SSG = true;
/* harmony default export */ var pages = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);